export default __webpack_public_path__ + "static/media/CFA_Coiffure.5f7257cc.png";